import { render, staticRenderFns } from "./ResultsTabNotCome.vue?vue&type=template&id=aa81ed0c&lang=pug&"
import script from "./ResultsTabNotCome.vue?vue&type=script&lang=js&"
export * from "./ResultsTabNotCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports